import React from "react";
import BalanceStatCard from "./cards/BalanceStatCard";
import CollectionsStatCard from "./cards/CollectionsStatCard";
import DisbursementsStatCard from "./cards/DisbursementsStatCard";

export default function DashboardStats() {
  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-12">
      <BalanceStatCard />
      <CollectionsStatCard />
      <DisbursementsStatCard />
    </div>
  );
}
